import jsonpath from "jsonpath";

export const asJSONPath = (prefix, obj) => {
    const m = {};
    for (const k in obj) {
        if (!obj.hasOwnProperty(k)) { continue; }
        const nk = `${prefix}.${k}`;
        m[nk] = obj[k];
    }
    return m;
}

export const fromJSONPath = update => prevState => {
    const ns = {...prevState};
    for (const k in update) {
        if (!update.hasOwnProperty(k)) { continue; }
        jsonpath.value(ns, `$.${k}`, update[k]);
    }
    return ns;
}